module.exports = __webpack_public_path__ + "img/lora-red.ab64a1ca.png";